import {
  Box, Button, Divider, Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { removePlayer, removePlayerFromTeam } from 'redux/slices';
import { RemovePlayer } from './RemovePlayer';

export default function CurrentPlayerCard({ player }) {
  const dispatch = useDispatch();

  const handleRemovePlayer = () => {
    dispatch(removePlayer(player.playerId));
    dispatch(removePlayerFromTeam({ teamId: player.teamId, playerId: player.playerId }));
  };

  return (

    <Box sx={{
      width: { xs: '100%', md: '80%' },
    }}
    >
      <Box
        key={`${player.playerId}-${player.playerName}`}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          borderRadius: '5px',
          padding: '10px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          <Typography variant="h6">{player.playerName}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleRemovePlayer}
          >
            Remover
          </Button>
          <RemovePlayer playerId={player.playerId} isPlaying={handleRemovePlayer} />
        </Box>
      </Box>
      <Divider variant="fullWidth" />
    </Box>
  );
}
